export enum PumpScheduleStageTabs {
    Events = 0,
    FluidDetails = 1,
    TestResults = 2
}
